import * as React from 'react';
import { SmartPasteButton } from '@syncfusion/ej2-buttons';
import { ComponentBase, applyMixins } from '@syncfusion/ej2-react-base';
/**
 * `SmartPasteButtonComponent` represents the react Smart Paste Button Component.
 * ```html
 * <SmartPasteButtonComponent>Smart paste</SmartPasteButtonComponent>
 * ```
 */
export class SmartPasteButtonComponent extends SmartPasteButton {
    constructor(props) {
        super(props);
        this.initRenderCalled = false;
        this.checkInjectedModules = false;
        this.statelessTemplateProps = null;
        this.templateProps = null;
        this.immediateRender = true;
        this.isReactMock = true;
        this.portals = [];
    }
    render() {
        this.isReactMock = false;
        if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
            super.render();
            this.initRenderCalled = true;
        }
        else {
            return React.createElement('button', this.getDefaultAttributes(), [].concat(this.props.children, this.portals));
        }
    }
}
applyMixins(SmartPasteButtonComponent, [ComponentBase, React.Component]);
